<script setup lang="ts">
import { computed, inject, type WritableComputedRef } from 'vue'
import { i18n } from '@/i18n'
import {
  customElementPropsKey,
  FrontendTemplate,
} from '@/types/customElementProps.types'
import { mdiChevronDown } from '@mdi/js'

interface LanguageItem {
  label: string
  translation: string
  url: string
}

const templateProps = inject(customElementPropsKey)

const availableLanguages = computed<LanguageItem[]>(
  () =>
    templateProps?.supportedLocales?.map(locale => ({
      ...locale,
      translation: `language.${locale.label}`,
    })) ?? [],
)

const currentLanguage = computed(() =>
  availableLanguages.value.find(
    ({ label }) =>
      label ===
      ((i18n.global.locale as unknown as WritableComputedRef<string, string>)
        .value || i18n.global.locale),
  ),
)

const showComponent = computed(
  () => templateProps?.template !== FrontendTemplate.ERROR,
)

async function updateLanguage(item: LanguageItem) {
  window.location.href = item.url
}
</script>

<template>
  <v-select
    v-if="availableLanguages.length > 1 && showComponent"
    density="compact"
    :menu-icon="mdiChevronDown"
    class="elevation-0 density--ultra-compact"
    :items="availableLanguages"
    :model-value="currentLanguage"
    :item-title="item => $t(item.translation)"
    item-value="label"
    return-object
    hide-details
    @update:model-value="updateLanguage"
  />
</template>

<style lang="css" scoped>
.density--ultra-compact {
  transform: scale(0.75);
}
</style>
